import React, { useState, useEffect } from "react"; 
import "../CSS/ServiceSecondSection.css";
import axios from "axios";

const ServiceSecond2 = ({ title }) => {
  const [data, setData] = useState(null);
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0); // Index for categories
  const [currentPointIndex, setCurrentPointIndex] = useState(0); // Index for points
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://us-central1-balajibadmintonacademy.cloudfunctions.net/api/getsecondserviceContent",
          { params: { title } }
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("");
      }
    };

    fetchData();
  }, [title]);

  useEffect(() => {
    // Change category every 10 seconds
    const categoryInterval = setInterval(() => {
      setCurrentCategoryIndex((prevIndex) => {
        const categoryKeys = Object.keys(data || {});
        return (prevIndex + 1) % categoryKeys.length;
      });
      setCurrentPointIndex(0); // Reset point index when category changes
    }, 10000);

    return () => clearInterval(categoryInterval);
  }, [data]);

  useEffect(() => {
    // Change point every 2 seconds
    const pointInterval = setInterval(() => {
      const categoryKeys = Object.keys(data || {});
      const currentCategory = categoryKeys[currentCategoryIndex];
      const points = data?.[currentCategory]?.filter((point) => point !== null) || [];
      setCurrentPointIndex((prevIndex) => (prevIndex + 1) % points.length);
    }, 2000);

    return () => clearInterval(pointInterval);
  }, [data, currentCategoryIndex]);

  if (error) {
    return <p>{error}</p>;
  }

  const categoryKeys = Object.keys(data || {});
  const currentCategory = categoryKeys[currentCategoryIndex];
  const points = data?.[currentCategory]?.filter((point) => point !== null) || [];

  return (
    <section id="customer" className="section overflow-hidden pointsection">
      <div className="servicontainer4" style={{ marginTop: "20px" }}>
        <div className="page-padding mb-4">
          <div className="v-flex gap-64">
            <div className="service_s2-wrapper">
              <div className="service_s2-layout">
              <div id="w-node-_27ba9e62-e568-11de-110f-f7cba7538575-299e36c2" className="text-block">OVERVIEW</div>
                <h1 className="h-44 service_s2-heading">
                  {currentCategory} Coaching
                </h1>
                <div className="service_s2-content-wrapper">
                  {points.length > 0 ? (
                    points.map((point, index) => (
                      <div
                        key={index}
                        className={`service_s2-content ${
                          currentPointIndex === index ? "highlight" : ""
                        }`}
                      >
                        <div className="number">
                          {index + 1 < 10 ? `0${index + 1}` : index + 1}
                        </div>
                        <div className="p1">{point}</div>
                      </div>
                    ))
                  ) : (
                    <p>No points available</p>
                  )}
                  <div className="blob"></div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
        
      </div>
    </section>
  );
};

export default ServiceSecond2;
